import * as Sentry from "@sentry/react";
import Application from "../apiResources/Application";

const updateApplication = async (data) => {
  let application = {};

  try {
    const { ...attributes } = data;
    application = await Application.find(data.applicationId);

    application.data.assignAttributes(attributes);

    await application.data.save();
  } catch (error) {
    Sentry.captureException(error);
  }

  return application;
};

export default updateApplication;
